export var DATE_PICKER_MONTH_YEAR_SELECTOR_CLASS_PREFIX = 'DatePickerMonthYearSelector';
export var MONTH_NAMES_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export var YEAR_SELECTOR_SCROLL_TOP = 195;
export var YEAR_SELECTOR_RANGE_DELTA = 5;